<!-- Header -->
<ckeditor [(ngModel)]="newNote.note" [editor]="textEditor" [config]="editorConfig"></ckeditor>

<button class="mt-3 btn btn-primary gap-4" [disabled]="disabled" (click)="addNote()">
    <iota-icon icon="plus"></iota-icon>
    <span i18n>Add note</span>
</button>

<div class="flex flex-col gap-4 mt-4">
    <div class="rounded-lg shadow-lg mb-4" *ngFor="let note of notesContainer">
        <div class="rounded-t-lg flex flex-row items-center gap-2 text-xs bg-base-300 p-2">
            <span class="flex flex-row items-center gap-2">
                <iota-icon icon="clock"></iota-icon> {{ note.creationDateTime | date: 'dd.MM.yyyy HH:mm' }}
            </span>
            <span class="flex flex-row items-center gap-2"> <iota-icon icon="user"></iota-icon> {{ note.creationBy }} </span>

            <div class="grow"></div>

            <button
                class="btn btn-ghost btn-sm"
                [disabled]="disabled"
                *ngIf="(user$ | ngrxPush)?.userId === note.creationById"
                (click)="deleteNote(note)"
            >
                <iota-icon icon="trash"></iota-icon>
            </button>
        </div>

        <div class="px-2 py-4 text-sm ck-content" [innerHTML]="note.note"></div>
    </div>
</div>
